import { Common } from '@stockbit/ui';
import { Title } from '../styled';
import {
  KomisiContainer,
  KomisiList,
  KomisiNumber,
  KomisiTitle,
} from './styled';

const { Text } = Common;

const MulaiInvestasiKomisi = () => (
  <KomisiContainer>
    <Title>Biaya Komisi</Title>
    <KomisiList>
      <div>
        <KomisiTitle>Fee Beli</KomisiTitle>
        <KomisiNumber>0,15%</KomisiNumber>
      </div>
      <div>
        <KomisiTitle>Fee Jual</KomisiTitle>
        <KomisiNumber>0,25%</KomisiNumber>
      </div>
    </KomisiList>
    <Text size="20px" align="center" padding="15px 60px" as="div">
      <Text size="20px" family="bold" as="b">
        Keterangan:
      </Text>{' '}
      Sudah termasuk biaya broker, biaya levy (BEI, KPEI, KSEI) 0,043%, PPN biaya
      <br />
      broker 10%, dan PPh final untuk transaksi jual 0,1%.
    </Text>
  </KomisiContainer>
);

export default MulaiInvestasiKomisi;
